module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/house-question-mark-e6e772d333a950fbc6ab6f7bc3b5b169.svg";